import { Category, SubCategory } from "../../Types/types";

export const mapSubCategoriesToCategories = (
  subCategoryData: SubCategory[]
): Record<string, string> => {
  const map: Record<string, string> = {};
  subCategoryData.forEach((subCategory) => {
    map[subCategory.id] = subCategory.category;
  });
  return map;
};

export const getSubCategoriesForCategory = (
  subCategoryData: SubCategory[],
  categoryName: string
): SubCategory[] => {
  return subCategoryData.filter(
    (subCategory) => subCategory.category === categoryName
  );
};

export const categoryNameToIdMap = (
  categories: Category[]
): Record<string, number> => {
  return categories.reduce((map, category) => {
    map[category.name] = category.id;
    return map;
  }, {} as Record<string, number>);
};
